import request from '@/utils/request'

// 部门列表
export const getDepartmentList = () => request({
  url: '/workOnLine/employ/open/department/list',
  method: 'get'
})
// 分类列表
export const getCategoryList = () => request({
  url: '/workOnLine/employ/open/category/list',
  method: 'get'
})
// 收藏列表
export const getCollectionList = (params) => request({
  url: '/workOnLine/employ/getUserCollectEmployList',
  method: 'get',
  params
})
// 收藏服务
export const collectService = (employId) => request({
  url: '/workOnLine/employ/collectEmploy',
  method: 'post',
  params: { employId }
})